import styles from './style/RegistrationCountCell.module.scss';

const clampPercent = (registered, capacity) => {
  if (typeof capacity !== 'number' || capacity <= 0) {
    return null;
  }
  return Math.min(100, Math.round((registered / capacity) * 100));
};

const RegistrationCountCell = ({
  registered,
  capacity,
  width = '112px',
  maxWidth,
  gap = '4px',
}) => {
  const regNum = Number(registered);
  const safeRegistered =
    Number.isFinite(regNum) && regNum >= 0 ? Math.floor(regNum) : 0;
  const capNum = capacity == null || capacity === "" ? NaN : Number(capacity);
  const safeCapacity =
    Number.isFinite(capNum) && capNum > 0 ? capNum : null;
  const hasCapacity = safeCapacity != null;
  const percent = hasCapacity
    ? clampPercent(safeRegistered, safeCapacity)
    : null;

  return (
    <div className={styles.root}>
      <div className={styles.countLine}>
        <span className={styles.registered}>{safeRegistered}</span>
        <span className={styles.slash}>/</span>
        <span className={styles.capacity}>{hasCapacity ? safeCapacity : '-'}</span>
      </div>
      <div className={styles.meterRow} style={{ gap }}>
        <div
          className={styles.track}
          style={{
            width,
            maxWidth: maxWidth || width,
          }}
          role={hasCapacity ? 'progressbar' : undefined}
          aria-valuenow={hasCapacity ? percent : undefined}
          aria-valuemin={hasCapacity ? 0 : undefined}
          aria-valuemax={hasCapacity ? 100 : undefined}
          aria-label={hasCapacity ? `報名比例 ${percent}%` : undefined}>
          {hasCapacity ? <div className={styles.fill} style={{ width: `${percent}%` }} /> : null}
        </div>
        <span className={styles.percent}>{hasCapacity ? `${percent}%` : '-'}</span>
      </div>
    </div>
  );
};

export default RegistrationCountCell;
